"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require("./AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _setInputFocus = require("./utils/setInputFocus");

var _setInputFocus2 = _interopRequireDefault(_setInputFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Předek pro komponenty, které chtějí nastavovat focus po zobrazení, typicky se jedná o formuláře.
 *
 * Použití:
 *
 * class CustomKomponent extends FocusableReactComponent {
 *   componentDidMount() {
 *     // Po umístění komponenty chceme povolit nastavení focusu
 *     this.enableSetFocus(ReactDOM.findDOMNode(this.refs.form));
 *   }
 *
 *   componentDidUpdate() {
 *     // Po aktualizaci dom se nastaví focus pokud ještě nastaven nebyl
 *     this.setFocus(ReactDOM.findDOMNode(this.refs.form));
 *   }
 * }
 */
var FocusableReactComponent = function (_AbstractReactCompone) {
    (0, _inherits3.default)(FocusableReactComponent, _AbstractReactCompone);

    function FocusableReactComponent(props) {
        (0, _classCallCheck3.default)(this, FocusableReactComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FocusableReactComponent.__proto__ || (0, _getPrototypeOf2.default)(FocusableReactComponent)).call(this, props));

        _this.enableSetFocus = function (el) {
            // console.log("ENABLE SET FOCUS...");
            _this.canSetFocus = true;
            _this.setFocus(el);
        };

        _this.setFocus = function (el) {
            if (!_this.focusWasSet && _this.canSetFocus && el) {
                // console.log("SETTING FOCUS...", el);
                _this.focusWasSet = true;
                setTimeout(function () {
                    (0, _setInputFocus2.default)(el);
                }, 1);
            }
        };

        _this.focusWasSet = false;
        _this.canSetFocus = false;
        return _this;
    }

    /**
     * Povolení od kdy je možné pokusit se nastavit focus, pokud je již možné focus nastavit na el, rovnou se to provede.
     * @param el element, ve kterém jsou prvky, které mají dostat focus, např. formulář
     */


    /**
     * Pokus o nastavení focusu, pokud již focus byl nastaven, nic se neděje.
     * @param el element, ve kterém jsou prvky, které mají dostat focus, např. formulář
     */


    return FocusableReactComponent;
}(_AbstractReactComponent2.default); // -


exports.default = FocusableReactComponent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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